import { render } from "./index.vue?vue&type=template&id=39cf52d9&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=39cf52d9&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cf52d9"]])

export default __exports__